<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">管理员列表</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
            <div style="display:inline-block;" v-if="isbutShow.selectBut">
             <template>
                <Input v-model="key" placeholder="用户名" style="width: 300px"></Input>
            </template>
              
              <Button type="ghost" class="mRight mLeft" @click="showKeyList()" v-if="isbutShow.selectBut">查询</Button>
              
            </div>
          
            <Button @click="addAdmin" type="primary" class="mRight" v-if="isbutShow.addBut">新增</Button>
            <Button @click="upDateAdmin" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
            <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delAdmins">删除</Button>
             
          </div>

          <div class="clearfix"></div>

          <div class="table-wrapper">
            <!-- <Table  border :columns="columns4" :data="nodes"></Table> -->
            <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>

        </div>
      </div>


    </div>

  <!-- 新增admin  / 修改-->
    <Modal
      v-model="addModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{modelName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="用户名" prop="name">
                  <Input v-model="formValidate.name" placeholder="请输入用户名"></Input>
              </FormItem>
              <FormItem label="密码" prop="passwd" style="position:relative;">
                  <span class="star" v-if=" modelName == '新增' ">*</span>
                  <Input type="password" v-model="formValidate.passwd"  ref="pwd1"  placeholder="请输入密码"></Input>
              </FormItem>
              <FormItem label="确认密码" prop="passwdCheck" style="position:relative;">
                  <span class="star" style="left:-70px" v-if=" modelName == '新增' ">*</span>
                  <Input type="password" v-model="formValidate.passwdCheck"  ref="pwd2" placeholder="请输入确认密码" v-on:click="this.CheckPasswd()"></Input>
              </FormItem>
               <FormItem label="所属部门" prop="dePtNode">
                  <!-- <Button type="default" long  @click="getDepartment">所属部门</Button>    -->
                  <!-- {{treeNode}} -->
                  <Button type="default" long style="text-align:left;" @click=" modalDept = true " >{{treeNode}}</Button>
              </FormItem>
              <FormItem label="邮箱" prop="mail">
                  <Input v-model="formValidate.mail" placeholder="请输入邮箱"></Input>
              </FormItem>
               <FormItem label="手机号" prop="phone">
                  <Input v-model="formValidate.phone" placeholder="请输入手机号" v-on:blur="isMobile()" ></Input>
              </FormItem>
              <FormItem label="角色" prop="role">
                     <Button type="default" long style="text-align:left;" @click=" modalRole = true " >{{roleNode}}</Button>
                  
              </FormItem>
              <FormItem label="状态" prop="status" style="text-align:left;">
                  <RadioGroup v-model="formValidate.status">
                    <Radio label="0" :class="[formValidate.status == '0' ? 'ivu-radio-checked' : '']">禁用</Radio>
                    <Radio label="1" :class="[formValidate.status == '1' ? 'ivu-radio-checked' : '']">正常</Radio>
                </RadioGroup>
              </FormItem>
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit('formValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
  <!-- 所属部门 -->
  <Modal
        title="所属部门"
        v-model="modalDept"
        :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>所属部门</span>
        </p>
        <div style="text-align:center">
         <tree-com 
         :deptData = "deptLists" 
         :selectedId = "dePtNodeSelect" 
         v-on:getTree = 'getDeptNodes'
          ></tree-com> 
        </div>
        <div slot="footer">
             <Button type="primary" @click="closeDeptModal()" long   >确定</Button>
        </div>
  </Modal>

   <!-- 角色 -->
  <Modal
        title="角色"
        v-model="modalRole"
        :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>角色</span>
        </p>
        <div style="text-align:center">
            <!-- <Select v-model="formValidate.role" placeholder="请选择角色">
                <Option :value="item.roleId" :class="[formValidate.role == item.roleId ? 'ivu-select-selected-value' : '']"  v-for="item in roleLists"  label-in-value="true" >{{item.roleName}}</Option>
            </Select> -->
            <!-- {{roleLists}} -->
            <!-- {{formValidate.role}} -->
            <!--  -->
            <Row>
              <Col>
                  <Select v-model="roleIdList"  filterable multiple  @on-change="selectRole" :label-in-value="true">
                    <Option v-for="(item,index) in roleLists" :value="item.roleId" :label="item.roleName" :class="[roleIdList[index] == item.roleId ? 'ivu-select-item-selected' : '']" >{{item.roleName }}</Option>
                   </Select>
              </Col>
          </Row>

        </div>
        <div slot="footer">
             <Button type="primary" @click="closeRoleModel()" long   >确定</Button>
        </div>
  </Modal>
  
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
 .ivu-select-multiple .ivu-tag {
    display: none !important;
  }
  .star{
    font-family: SimSun;
    font-size: 12px;
    color: rgb(237, 63, 20);
    font-weight: 600;
    position: absolute;
    left: -45px;
    top: 0;
  }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  import treeCom from '../../components/tree'
  // import dateformat from '../../util/dateformat' 

  // import api from '../../api/commonApi'
  export default{
    data(){
      //  const validatePass = (rule, value, callback) => {
      //     if (value === '') {
      //         callback(new Error('请输入密码'));
      //     } else {
      //         if (this.formValidate.passwdCheck !== '') {
      //             // 对第二个密码框单独验证
      //             this.$refs.formValidate.validateField('passwdCheck');
      //         }
      //         callback();
      //     }
      // };
      // const validatePassCheck = (rule, value, callback) => {
      //     if (value === '') {
      //         callback(new Error('请再次输入密码'));
      //     } else if (value !== this.formValidate.passwd) {
      //         callback(new Error('两次输入密码不匹配!'));
      //     } else {
      //         callback();
      //     }
      // };
      const validatePhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('Age cannot be empty'));
                }
                // 模拟异步验证效果
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('手机号不能为空'));
                    } else {
                        if (!/^1\d{10}$/.test(value)) {
                            callback(new Error('手机号格式不正确'));
                        } else {
                            callback();
                        }
                    }
                }, 1000);
            };
      return {
       isbutShow:{
        addBut: false,
        delBut: false,
        updateBut: false,
        selectBut: false,
       },
        modalRole:false,
        modelName:'新增',
        roleNode:'选择角色',
        key:'',
        roleLists:[],
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        roleIdList: [],
        columns7: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: 'ID',
                key:'userId',
                width: 60,
                align: 'center'
            },
            {
                title: '用户名',
                key: 'username',
                align: 'center'
            },
            {
                title: '所属部门',
                key: 'deptList',
                align: 'center',
                render:(h, params) => {
                  const row = params.row;
                  const object = row.deptList;
                  var deptName = "";
                  object.forEach(r=>{  
                      deptName+= r.name+"," 
                  })  

                  return h('span',deptName );
                }
            },
            {
                title: '邮箱',
                key: 'email',
                align: 'center'
            },
            {
                title: '电话',
                key: 'mobile',
                align: 'center'
            },
            {
                title: '状态',
                key: 'status',
                align: 'center',
                render: (h, params) => {
                    const row = params.row;
                    const color = row.status === 1 ? 'success' : 'default';
                    const text = row.status === 1 ? '正常' : '禁用';

                    return h('Button', {
                        props: {
                            type: color,
                            size: 'small'
                        }
                    }, text);
                }
            },
            {
                title: '创建时间',
                key: 'createTime',
                align: 'center',
            },
        ],
        addModel: false,
        updateModel:false,
        modalDept:false,
        resourcesDept:[],
        treeNode:'所属部门',
        treeNodeId:'',
        roleDate:[],
        deptLists:[],
        selnodeType: '',
        nodeNumber: 1,
        editNodeModel: false,
        selNodetoEdit: {},
        selectionRows:{},
        updateId:'',
        permissionsLists:[],
        dePtNodeSelect:[],
        formValidate: {
            name: '',
            passwd:'',
            passwdCheck:'',
            dePtNode:'',
            mail: '',
            phone: '',
            role:'',
            status: '',
        },
        ruleValidate: {
            name: [
                { required: true, message: '用户名不能为空', trigger: 'blur' }
            ],
            // passwd:[
            //     { required: true,validator: validatePass, trigger: 'blur' },
            //     { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur'}
            // ],
            // passwdCheck:[
            //     { required: true,validator: validatePassCheck, trigger: 'blur' }
            // ],
            dePtNode:[
               { required: true, message: '所属部门不能为空',  trigger: 'blur' }
            ],
            mail: [
                { required: true, message: '邮箱不能为空', trigger: 'blur' },
                { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
            ],
            phone:[
               { required: true, message: '手机号不能为空', trigger: 'blur' },
               {validator(rule, value, callback, source, options) {
                  var errors = [];
                  if(!/^1\d{10}$/.test(value)) {
                    // errors.push(
                        callback('手机号格式不正确');
                    }
                    callback(errors);
                }}

            ],
            role:[
                 { required: true, message: '角色不能为空', trigger: 'blur' }
            ]
            // status: [
            //     { required: true, message: '状态不能为空', trigger: 'change' }
            // ],
           
        },
        modal_loading: false,
      
      }
    },
    mounted:function(){  
      // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        console.log(r.name)
        if(r.name == "查看"){
          this.isbutShow.selectBut = true;
        }else if(r.name == "新增"){
          this.isbutShow.addBut = true;
        }else if(r.name == "修改"){
          this.isbutShow.updateBut = true;
        }else if(r.name == "删除"){
           this.isbutShow.delBut = true;
        }

      })
       // ----------- 权限显示end -------------

        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        this.getDepartment();
        this.getRole();  //获取角色
    },
    methods: {
        getRole(){
            api.Role.roleLists({
            }, resp => {
              console.log(resp)
               this.roleLists = resp.roleList;
            }, error => {

            })
        },
        closeRoleModel(){
            // console.log(this.roleIdList)
            // 当选中角色ID长度为空，报错
            if(this.roleIdList.length == 0){
                this.$Message.error('请选择角色!');
            }else{  // 当选中角色ID长度不为空
                this.formValidate.role = "";
                // this.formValidate.role = this.roleIdList; //赋值
                // console.log(this.formValidate.role)
                var object = this.roleDate;
                var roleNode = '';
                this.roleNode = ""; // 置空

                object.forEach(r=>{
                  // console.log(r)

                   roleNode += r.label + ',';
                })
                this.roleNode = roleNode;  // 获取角色node显示文字
                this.formValidate.role =  roleNode; //赋值
                // console.log(this.formValidate.role);
                this.modalRole = false;
            }
        }, 
        selectRole(item){
          console.log(item)
          this.roleDate = [];
          this.roleDate = item;
        },
        getLists(pageCurrent,pagesize){
            // var token = sessionStorage.getItem("token");
            api.User.getLists({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
              // console.log(resp)
               // 获取分页展示list
               this.pagerData.data = resp.page.list;
               // 获取分页总条数
               this.pagerData.page.totalCount = resp.page.totalCount;
              // this.getallgateway();
            }, error => {

            })
        },
        // 搜索关键词
        showKeyList(){
            // console.log(this.key);
            // var vue = this;
            // var token = sessionStorage.getItem("token")
            //if(this.key == ''){
                 //this.$Message.error('查询关键词不能为空!');
            //}else{
              // console.log('通过关键词获取列表')
               api.User.getLists({
                    'page':this.pagerData.page.pageCurrent,
                    'limit':this.pagerData.page.pagesize,
                    'username':this.key,
                    // 'token':token
                }, resp => {
                  // console.log(resp)
                  // 获取分页展示list
                   this.pagerData.data = resp.page.list;
                   // 获取分页总条数
                   this.pagerData.page.totalCount = resp.page.totalCount;
                   //this.key = '';
                }, error => {
                  
                })

            //}
        },
        getDepartment:function(){
            api.Dept.treeList({

            }, resp => {
              // console.log(resp)
              this.deptLists = resp.deptList;
              // console.log(this.deptLists)
            }, error => {
              
            })
        },
        getDeptNodes:function(tree){   // 获得tree选中节点  
            // console.log(tree)
            // console.log(tree.name.length)
            if(tree.name.length !== 0){
              this.treeNode = "";
              for(var i=0;i<tree.name.length;i++){
                this.treeNode += tree.name[i] + ","
              }
              this.treeNodeId = tree.deptId;
              // console.log(this.treeNode)
              // console.log(this.treeNodeId)
            }else{
              this.treeNode = "所属部门";
            }
            
            
        },
        closeDeptModal:function(){
            console.log(this.treeNode)
            if(this.treeNode == '所属部门'){
              this.$Message.error('请选择所属部门!');
            }else{
              this.modalDept = false;
              this.formValidate.dePtNode = this.treeNode;
            }
            
        },
        handleSubmit (name) {
           // console.log(this.formValidate)
            this.$refs[name].validate((valid) => {
                if (valid) {
                  if(this.formValidate.status == ''){
                    this.$Message.error('状态不能为空!');
                  }
                  if(this.formValidate.dePtNode == ''){
                    this.$Message.error('请选择所属部门!');
                  }
                  if(this.modelName == "修改"){
                    api.User.updateAdmin({
                      "username": this.formValidate.name,
                      "password": this.formValidate.passwd,
                      "email": this.formValidate.mail,
                      "mobile": this.formValidate.phone,
                      "deptIdList": this.treeNodeId,
                      "role":this.formValidate.role,
                      "status": this.formValidate.status,
                      "userId": this.updateId,
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改成功!');
                        this.addModel = false;
                        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                      }else{
                           this.$Message.error('修改失败：'+ resp.msg);
                      }
                      

                    }, error => {

                    })
                  }else if(this.modelName == "新增"){
                    // 新增验证输入密码和确认密码
                    if(this.formValidate.passwd === ""){
                        this.$Message.error('请输入密码');
                        return;
                    }
                    if(this.formValidate.passwdCheck === ""){
                        this.$Message.error('请再次输入密码');
                        return;
                    }
                    if (this.formValidate.passwdCheck !== this.formValidate.passwd) {
                        this.$Message.error('两次输入密码不匹配!');
                        return;
                    }
                   
                    // console.log(this.treeNodeId)
                    api.User.addAdmin({
                      "username": this.formValidate.name,
                      "password": this.formValidate.passwd,
                      "email": this.formValidate.mail,
                      "mobile": this.formValidate.phone,
                      "deptIdList": this.treeNodeId,
                      "status": this.formValidate.status,
                      "roleIdList":this.roleIdList,
                      "customerId":JSON.parse(localStorage.getItem('user')).customerId
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增成功!');
                        this.addModel = false;
                        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                      }else {
                        this.$Message.error('新增失败：'+ resp.msg);
                      }
                      

                    }, error => {
                        this.$Message.error('新增失败：'+ resp.msg);
                    })
                  }
                  
                    
                } else {
                    this.$Message.error('Fail!');
                }
            })
           

        },
       
        // 删除/批量删除
        delAdmins(){
            // this.selectionRows = this.getSelection();
            if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
               this.$Message.error('请至少选择一条记录!');
                return;
            }
            var userIds = [];
            for(var i=0 ;i < this.selectionRows.length; i++){
                console.log(i);
                userIds.push(this.selectionRows[i].userId);
            }
            console.log(userIds)
            // 执行删除
            this.delAdmin(userIds);
        },
        // 新增 初始化数据
        addAdmin:function(){
            this.modelName = '新增';
            this.treeNode = "所属部门";
            // console.log(this.selectionRows)
            // this.selectionRows = [];
            
            this.dePtNodeSelect = [];
            this.formValidate = {
              name: '',
              passwd:'',
              passwdCheck:'',
              dePtNode:'',
              mail: '',
              phone:'',
              role:'',
              status: '',
            }
            this.addModel = true;
        },

        // 修改
        upDateAdmin:function(index){
          this.modelName = '修改';
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.selectionRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }
          // var userId = []
          // console.log(this.selectionRows)
          // userId.push(this.selectionRows[0].userId);
          // console.log(userId)
          this.updateId = this.selectionRows[0].userId

          
           var object = this.selectionRows[0].deptList;
           var roleObject = this.selectionRows[0].roleList;
           var deptName = "";
           var roleName = "";
           var DeptId = [];
           // console.log(this.selectionRows[0]);
           // 
            if(object.length !== 0){
              object.forEach(r=>{ 
                  deptName += r.name + ",";
                  DeptId.push(r.deptId)
              }) 
            } 
            console.log(roleObject)
            if(roleObject.length !== 0){
              roleObject.forEach(r=>{  
                console.log(r)
                roleName += r.roleName  + ",";
                this.roleIdList.push(r.roleId)
              }) 
            }
             
            // console.log(deptName)
            // console.log(DeptId)
            // console.log(this.selectionRows[0]);
        //   this.treeNode = deptName;
           if(deptName == null || deptName == "" || deptName == undefined){
              this.treeNode = "所属部门"
            }else{
              this.treeNode = deptName;
            }
            if(roleName == null || roleName == "" || roleName == undefined){
              this.roleNode = "选择角色"
            }else{
              this.roleNode = roleName;

            }

            
          this.dePtNodeSelect = DeptId;
          this.formValidate = {
            name: this.selectionRows[0].username,
            passwd:'',
            passwdCheck:'',
            dePtNode: this.treeNode,
            mail: this.selectionRows[0].email,
            phone: this.selectionRows[0].mobile,
            role: this.roleIdList,
            status: this.selectionRows[0].status,
          }
          console.log(this.formValidate)
          this.addModel = true;
          
        },
        // 当前表格选中项
        getSelection:function(selection){
          // console.log(222)
            // console.log(selection)
            this.selectionRows = selection;
            // return selection;
        },

        // 分页 -- 页数改变
        onChange:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.pagerData.page.pageCurrent = curpage;
            this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pagerData.page.pagesize = size;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        } ,
        delAdmin:function(userIds){
          // JSON.stringify(userIds)
           api.User.delAdmin(userIds , resp => {
               console.log(resp)
               if(resp.code == 0){
                 this.$Message.success('删除成功!');
                 this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
               }else {
                  this.$Message.error('删除失败：'+ resp.msg);
               }
              
             
            }, error => {
              
            })
         
        }

    },

      components: {treeCom}
    }
</script>



// WEBPACK FOOTER //
// lists.vue?69d91b48